import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

const propTypes = exact({
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeOption: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
});

const defaultProps = {
  activeOption: null,
};

function ButtonToggle({ options, activeOption, handleChange }) {
  return (
    <div className="ButtonToggle">
      <ul className="ButtonToggle_list">
        {options.map((option) => (
          <li className="ButtonToggle_listItem" key={option.value}>
            <button
              type="button"
              className={classNames('ButtonToggle_button', {
                active: option.value === activeOption,
              })}
              onClick={() => handleChange(option.value)}
            >
              {option.text}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

ButtonToggle.propTypes = propTypes;
ButtonToggle.defaultProps = defaultProps;

export default ButtonToggle;
